import { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import * as siteManagementService from '../../../services/siteManagementService'
import styles from './ManageSiteAttachments.module.css'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import SearchBar from "../../../components/Miscellaneous/SearchBar"
import ManageAttachment from '../../../components/Home/ManageSiteAttachments/ManageAttachment'
import BackSaveContinueButton from '../../../components/Miscellaneous/BackSaveContinueButton'
const ManageSiteAttachments = ({user }) => {
    // State
    const [loaded, setLoaded] = useState(false)
    const [attachmentNameFilter, setAttachmentNameFilter] = useState("")
    const [isCleared, setIsCleared] = useState(false)
    const [editingId, setId] = useState();
    const [attachments, setAttachments] = useState([])
    const [attachmentTypes, setAttachmentTypes] = useState([])
    const [create, setCreate] = useState(false)
    const [createRefresh, setCreateRefresh] = useState(false)
    const [attachmentFile, setAttachmentFile] = useState();
    const [continueButtonVisibility, setContinueButtonVisibility] = useState(false)
    const navigate = useNavigate()
    const [formData, setFormData] = useState(
        {
            id: null,
            fileName: null,
            fileType: null,
            fileExtension: null,
            displayName: null,
            description: null,
            attachmentTypeName: null,
            attachmentType: null,
            attachmentBase64: null,
        }
    )
    // ------ Name Search ------ //
    const attachmentFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        attachments.forEach((item) => {
            const fileName = item.fileName ? item.fileName.toLowerCase() : "";
            const displayName = item.displayName ? item.displayName.toLowerCase() : "";
            const description = item.description ? item.description.toLowerCase() : "";
            const attachmentTypeName = item.attachmentTypeName ? item.attachmentTypeName.toLowerCase() : "";

            if (!filterString || fileName.includes(filterString) || displayName.includes(filterString)
                || description.includes(filterString) || attachmentTypeName.includes(filterString)) {
                filtered.push(item)
            }
        })
        return filtered
    }
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const base64 = reader.result.split(',')[1]
                resolve(base64)
            }
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }
    const filteredByAttachmentName = attachmentFilter(attachmentNameFilter)
    const clearFilters = () => {
        setIsCleared(true)
        setAttachmentNameFilter("")
        setIsCleared(false)
    }

    const createAttachment = e => {
        e.preventDefault()
        // keeps previous entry, if cancelled
        setCreate(create ? false : true)
    }
    async function handleFileChange(e) {
        //https://stackoverflow.com/questions/39092859/get-dimensions-of-image-with-react
        let fileName = e.target.files[0].name;//str.substr(str.indexOf('.') + 1);
        const fileAndExtension = fileName.split('.');
        formData.fileName = fileAndExtension[0];
        formData.fileExtension = fileAndExtension[1];
        //"data:application/pdf;base64,@Model.Pdf"
        formData.fileType = e.target.files[0].type;
        setAttachmentFile(URL.createObjectURL(e.target.files[0]));
        formData.attachmentBase64 = await getBase64(e.target.files[0]);
    }
    const editAttachment = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(attachments)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (items.some(editableCheck)) {
            return
        }
        filtered.editable = true
        setId(divId)
    }
    const clearForm = () => {
        setFormData({
            id: null,
            fileName: null,
            fileType: null,
            fileExtension: null,
            displayName: null,
            description: null,
            attachmentTypeName: null,
            attachmentType: null,
            attachmentBase64: null,
        })
        setAttachmentFile(null);
    }
    const cancelEdit = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(attachments)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        clearForm();
        setId(null)
    }


    const createSaveRequest = (items) => {

        const fieldsSave = {
            'fileName': formData.fileName,
            'fileType': formData.fileType,
            'fileExtension': formData.fileExtension,
            'displayName': formData.displayName,
            'description': formData.description,
            'attachmentTypeName': formData.attachmentTypeName,
            'attachmentBase64': formData.attachmentBase64,
        }
        return fieldsSave
    }

    const handleChange = (e) => {

        if (e.target.type === 'select-one') {
            var foundType = attachmentTypes.find((item) => item.name === e.target.value);
            if (foundType) {
                formData.attachmentType = foundType;
                formData.attachmentTypeName = foundType.name;
            }
            else {
                formData.attachmentType = null;
                formData.attachmentTypeName = null;
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleContinueButtonVisiblity = () => {
        formData.fileName && formData.fileExtension && formData.description && formData.attachmentTypeName && attachmentFile
            ? setContinueButtonVisibility(true)
            : setContinueButtonVisibility(false)
    }

    const fetchAttachments = async () => {
        const attachs = await siteManagementService.getAttachments();
        if (attachs && attachs.length > 0) {
            const items = Array.from(attachs)
            for (let i = 0; i < items.length; i++) {
                items[i].editable = false;
            }
            setAttachments(attachs)
        }
        else {
            setAttachments([])
        }
        setCreateRefresh(false)
        setLoaded(true)
    }
    const fetchAttachmentTypes = async () => {
        const types = await siteManagementService.getAttachmentTypes();
        setAttachmentTypes(types)
    }
    useEffect(() => {
        fetchAttachmentTypes();
        fetchAttachments();
    }, [])
    useEffect(() => {
        if (formData.fileName) handleContinueButtonVisiblity()
    }, [formData.fileName])
    const handleSave = async (e) => {
        let saverequest = createSaveRequest();
        try {
            await siteManagementService.editAttachment(saverequest)
        } catch (err) {
            console.log(err)
        }
        setCreate(false)
        clearForm();
        setCreateRefresh(true)
        fetchAttachments()
    }
    const handleSaveAndNavigate = async (e) => {
        if (e) {
            e.preventDefault()
        }
        await handleSave()
        navigate(`/`)
    }

    return (
        <>
            {loaded ?
                <div className={styles.formAttachmentContainer}>
                    <h1>Manage Site Attachments</h1>
                    <BackSaveContinueButton
                        continueButtonVisibility={continueButtonVisibility}
                        handleSaveAndNavigate={handleSaveAndNavigate}
                        handleSave={handleSave}
                        styles={styles}
                        navigate={navigate}
                    />
                    <div className={styles.formAttachmentContainer}>
                        <button onClick={createAttachment} >
                            {!create ? "Add New Attachment" : "Cancel"}
                        </button><br />
                    </div>
                    {
                        create ?
                            <>
                                <div className={styles.formAttachmentContainer}>
                                    <div
                                        autoComplete="off"
                                        className={styles.container}
                                    >
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="fileName" title='File Name.' className={styles.label}>File Name:</label>
                                            <label className={styles.label} name="fileName" >{formData.fileName}</label>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="fileExtension" title='File extension.' className={styles.label}>File Extension:</label>
                                            <label className={styles.label} name="fileExtension" >{formData.fileExtension}</label>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="displayName" title='File display name.' className={styles.label}>Display Name:</label>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={formData.displayName}
                                                name="displayName"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="description" title='File description.' className={styles.label}>Description:</label>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                value={formData.description}
                                                name="description"
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <label htmlFor="attachmentTypeName" title='File attachment type.' className={styles.label}>Attachment Type:</label>
                                            <select
                                                name="attachmentTypeName"
                                                id={styles.ThirdPartyListDropdown}
                                                value={formData.attachmentTypeName}
                                                onChange={handleChange}
                                            >
                                                <option disabled={true} value="" selected="selected">
                                                    -- Select an option --
                                                </option>
                                                {
                                                    attachmentTypes.map((ci, idx) => (
                                                        <option key={idx}>{ci.name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <input type="file" onChange={handleFileChange} name="attachmentFile" />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <iframe src={attachmentFile} ></iframe>
                                        </div>
                                        
                                    </div>

                                </div>
                            </>
                            :
                            <></>
                    }
                    <div className={styles.containerAttachments} key={editingId}>
                        <SearchBar
                            searchName={attachmentNameFilter}
                            handleSearchName={setAttachmentNameFilter}
                            placeholder="FileName, DisplayName, Description, AttachmentType"
                            label="FileName"
                            isCleared={isCleared === true || isCleared === false ? isCleared : false}
                        />
                        {attachmentNameFilter ?
                            <button onClick={clearFilters} id={styles.clearFilters}>
                                Clear
                            </button>
                            :
                            <>
                            </>
                        }
                    </div>
                    <div className={styles.containerAttachments}>
                        {filteredByAttachmentName.length ?
                            <div className={styles.tableAttachmentsContainer}>
                                <table className={styles.tableAttachments}>
                                    <thead>
                                        <tr className={styles.trAttachments}>
                                            <th className={styles.thAttachments}>
                                                File Name
                                                <HoverButton
                                                    title={'Attachment name'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thAttachments}>
                                                Extension
                                                <HoverButton
                                                    title={'Attachment extension'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thAttachments}>
                                                Display Name
                                                <HoverButton
                                                    title={'Attachment display name'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thAttachments}>
                                                Description
                                                <HoverButton
                                                    title={'Attachment description'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thAttachments}>
                                                Type
                                                <HoverButton
                                                    title={'Attachment type'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.thAttachments}>
                                                Launch
                                                <HoverButton
                                                    title={'Launch to new browser'}
                                                    messageWidth={75}
                                                />
                                            </th>
                                            <th className={styles.validData}></th>
                                        </tr>
                                    </thead>
                                    <tbody key={filteredByAttachmentName.length}>
                                        {filteredByAttachmentName.map((item, index) => (
                                            <ManageAttachment
                                                index={index}
                                                attachment={item}
                                                attachmentTypes={attachmentTypes}
                                                editAttachment={editAttachment}
                                                cancelEdit={cancelEdit}
                                                key={index}
                                                editingId={editingId}
                                                getBase64={getBase64}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div>
                                <h2>No Editable Attachments or Missing Permissions</h2>
                            </div>
                        }
                    </div>
                </div>
                :
                <LoadingSpinner />
            }
        </>
    );
}

export default ManageSiteAttachments;
